const billionaireKuralinne = `

#### Who is Billionaire Kuralinne?
- **A wealthy benefactor** aiming to improve **Gaïa**.
- Needs **Refined Crystals of Devildom** to fund her efforts.
- Found in **Rondo**.

#### Increasing Server Drop Rate
- Donate **Refined Crystals of Devildom** to **increase the server-wide drop rate**.
- **The more Crystals donated, the higher the drop rate!**

![Kuralinne Donation Table](assets/guide/milliadaeringkurani.png)

#### Reset & Strategy
- **Drop rates reset every Wednesday**.
- **Best donation day: Thursday**, to maximize the full week's benefits.
- Donations **stack between players** until reaching **450 crystals**.

#### Why This Feature?
- Provides a use for **spare Crystals of Devildom** after **Fluminis’s armor set** completion.
- Allows **high-level players to support newcomers** while also benefiting themselves.

Make Gaïa a better place—support Billionaire Kuralinne today! 💎`;

export default billionaireKuralinne;
